import React, { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import QRCode from "qrcode-generator";
import "jspdf-autotable";
import moment from "moment";

import { useFetchData } from "../../hooks/useFetchData";
import { formatNumber, splitString } from "../../utils/data/essential";
import { Button } from "react-bootstrap";
import useAxios from "../../hooks/useAxios";

const PaymentInvoice = ({
  date,
  period,
  accountId,
  amount,
  billStatus,
  onHide,
  language,
  billId,
}) => {
  const [account, setAccount] = useState();
  const [location, setLocation] = useState();
  const [subscriber, setSubscriber] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const stringfiedPeriod = "" + period;
  const generatePDF = () => {
    // Create a new jsPDF instance
    const doc = new jsPDF();
    // Set up the content of the PDF
    const title = language?.kinya
      ? "REPUBULIKA Y'URWANDA"
      : "REPUBLIC OF RWANDA";
    const tableData = [
      {
        service: language?.kinya ? "Umusanzu w'irondo" : "Security Fee",
        monthlyAmount: `${formatNumber(amount)} RWF`,
        // month: moment(date).format("MM/YYYY"),
        month: moment(stringfiedPeriod, "YYYYMM").format("MM/YYYY"),
      },
    ];
    doc.setFontSize(12);
    doc.text(language?.kinya ? "Uwishyura:" : "Fee payer:", 145, 74);
    if (account?.accountName.length > 24) {
      const [firstPart, secondPart] = splitString(account?.accountName);
      doc.setFontSize(9);
      doc.text(firstPart, 168, 74);
      doc.text(secondPart, 168, 78);
    } else {
      doc.setFontSize(9);
      doc.text(account?.accountName, 168, 74);
    }

    // Set up the PDF content
    doc.setFontSize(18);
    doc.text(title, 15, 10);
    doc.setFontSize(13);
    doc.text(language?.kinya ? "UMUJYI WA KIGALI" : "CITY OF KIGALI", 15, 20);
    doc.addImage(
      `${process.env.PUBLIC_URL}/LOGO_COK.jpg`,
      "JPG",
      15,
      25,
      25,
      25
    ); // Adjust the coordinates and size as needed

    doc.setFontSize(12);
    doc.text(language?.kinya ? "Akarere:" : "District:", 15, 58);
    doc.text(language?.kinya ? "Umurenge:" : "Sector:", 15, 66);
    doc.text(language?.kinya ? "Akagari:" : "Cell:", 15, 74);
    doc.text(language?.kinya ? "Umudugudu:" : "Village:", 15, 82);
    doc.setFontSize(9);
    doc.text(location[1]?.name, 40, 58);
    doc.text(location[2]?.name, 40, 66);
    doc.text(location[3]?.name, 40, 74);
    doc.text(location[4]?.name, 40, 82);

    doc.setFontSize(12);
    doc.text(language?.kinya ? "Nimero:" : "Bill No:", 145, 58);
    doc.setFontSize(9);
    doc.text(`${billId}`, 168, 58);
    doc.text(moment(date).format("DD-MM-YYYY"), 168, 66);
    doc.text(`+${account?.accountNumber}`, 168, 82);
    doc.text(moment(date).format("DD-MM-YYYY"), 168, 66);
    if (subscriber?.tin) {
      doc.text(subscriber?.tin, 168, account.accountName.length > 24 ? 94 : 90);
    }
    doc.setFontSize(12);
    doc.text(language?.kinya ? "Itariki" : "Date:", 145, 66);
    doc.text(language?.kinya ? "Telephone" : "Phone No:", 145, 82);
    if (subscriber.tin) {
      doc.text(
        language.kinya ? "TIN:" : "TIN:",
        145,
        account.accountName.length > 24 ? 94 : 90
      );
    }
    doc.setFontSize(18);
    doc.text(
      language?.kinya ? "INYEMEZABUGUZI" : "INVOICE",
      language?.kinya ? 75 : 90,
      100
    );
    doc.setFontSize(15);
    doc.text(language?.kinya ? "UBUFASHA" : "HELP LINE", 90, 157);
    doc.setFontSize(12);
    doc.text(
      language?.kinya ? "Hamagara: 0788122922" : "Call center: 0788122922",
      20,
      165
    );
    doc.text(`Whatsapp: 0798113341`, 20, 173);
    doc.rect(15, 150, 182, 40);
    if (billStatus.id === 4) {
      doc.addImage(
        `${process.env.PUBLIC_URL}/paid_stamp.png`,
        "JPG",
        160,
        150,
        35,
        35
      );
    }

    const tableHeaders = [
      {
        header: language?.kinya ? "Serivisi" : "Service",
        dataKey: "servisi",
      },
      {
        header: language?.kinya ? "Ukwezi" : "Month",
        dataKey: "ukwezi",
      },
      {
        header: language?.kinya ? "Ayishyurwa" : "Amount",
        dataKey: "ayishyurwa",
      },
    ];
    const tableRows = tableData.map(({ service, monthlyAmount, month }) => [
      service,
      month,
      monthlyAmount,
    ]);
    tableRows.push([
      "",
      language?.kinya ? "Igiteranyo" : "Total",
      `${formatNumber(amount)} RWF`,
    ]);
    doc.autoTable({
      columns: tableHeaders,
      body: tableRows,
      startY: 113,
      margin: { top: 10 },
      didParseCell: function (data) {
        if (data.row.index === 1) {
          if (data.column.dataKey === "ukwezi") {
            data.cell.styles.fontStyle = "bold";
          }
        }
        if (data.row.index === 1) {
          if (data.column.dataKey === "ukwezi") {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.halign = "right";
          }
        }
      },
    });

    // Save the PDF
    // Generate QR Code
    const qr = QRCode(0, "L");
    qr.addData(`https://ituze.rw/invoice-verification/${billId}`);
    qr.make();

    // Draw QR Code on the PDF
    const qrImage = qr.createDataURL(4); // Adjust the size multiplier as needed

    doc.addImage(qrImage, "PNG", 168, 195, 35, 35); // Adjust the position and size as needed
    doc.setFontSize(9);
    doc.text("scan to verify", 173, 230);
    const pdfData = doc.output("datauristring");

    // Create a hidden link element
    const link = document.createElement("a");
    link.href = pdfData;
    link.download = `${language?.kinya ? "Inyemezabuguzi" : "Bill"}_${
      account.accountName
    }_${moment(date).format("MM/YYYY")}.pdf`;

    // Append the link to the document body
    document.body.appendChild(link);

    // Trigger a click event on the link
    link.click();

    // Remove the link from the document body after download
    document.body.removeChild(link);
  };

  const axiosInstance = useAxios();
  const { data } = useFetchData(
    ["fetch-specific-account"],
    `accounts/${accountId}`,
    true,
    user
  );
  useEffect(async () => {
    if (data) {
      setAccount(data);
      const { locationId } = data;
      try {
        const res = await axiosInstance.get(`/locations/${locationId}/details`);
        setLocation(res.data);
      } catch (error) {
        console.log(error);
      }
      const { subscriberId } = data;
      const res = await axiosInstance.get(`/subscribers/${subscriberId}`);
      setSubscriber(res.data);
    }
  }, [data]);
  return (
    <div className='d-flex justify-content-center'>
      <Button
        className='custom-btn-color'
        onClick={() => {
          generatePDF(date);
          onHide();
        }}
      >
        Download
      </Button>
    </div>
  );
};

export default PaymentInvoice;
